import React from 'react';
import { IUpcomingEventsPanel } from './interfaces';
import { ContentPanel } from '@components/ContentPanel';
import { Box, Button, Stack, Typography } from '@mui/material';

const EventItem = ({ title, date }: { title: string; date: string }) => (
  <Box>
    <Typography variant="body2" fontWeight={500}>
      {title}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {date}
    </Typography>
  </Box>
);

export const UpcomingEventsPanel: React.FC<
  IUpcomingEventsPanel
> = ({}): JSX.Element => {
  return (
    <ContentPanel borderRadius="none" title="Aankomende evenementen">
      <Stack spacing={1.5}>
        <EventItem title="Clubwedstrijd" date="Za 10 feb" />
        <EventItem title="Jeugdtraining" date="Wo 14 feb" />
        <EventItem title="Competitiedag" date="Zo 18 feb" />
      </Stack>

      <Button size="small" variant="outlined" fullWidth sx={{ mt: 2 }}>
        Toon alle evenementen
      </Button>
    </ContentPanel>
  );
};
